import { render, staticRenderFns } from "./Twitterhelp.vue?vue&type=template&id=ca3c0dac"
import script from "./Twitterhelp.vue?vue&type=script&lang=js"
export * from "./Twitterhelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports